import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import "./header-fix.css";
import App from "./App.jsx";
import { ThemeProvider } from "./contexts/ThemeContext.jsx";
import {
  trackWebVitals,
  monitorBundleSize,
  optimizeResourceLoading,
} from "./utils/performanceMonitor";
import { initHeaderFix } from "./utils/forceHeaderFixed";

// Initialize performance monitoring
trackWebVitals();
monitorBundleSize();
optimizeResourceLoading();

// Force header to stay fixed
initHeaderFix();

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </StrictMode>
);
